import { SafeError, SafePromise } from '@benzinga/safe-await';
import { ListenableSubscribable } from '@benzinga/subscribable';
import { PriceAlertsRestful } from './restful';
import { ingresAddUpdatePriceAlerts, ingresPriceAlerts } from './ingress';
import { Session } from '@benzinga/session';
import { PriceAlerts } from './proto/price_alerts_protos';

interface PriceAlertsErrorEvent {
  error: SafeError;
  errorType:
    | 'get_price_alerts_error'
    | 'add_price_alert_error'
    | 'delete_price_alert_error'
    | 'update_price_alert_error';
  type: 'error';
}

interface AddPriceAlertEvent {
  type: 'add_update_price_alert';
}
export type PriceAlertsRequestEvent = PriceAlertsErrorEvent | AddPriceAlertEvent;

export class PriceAlertsRequest extends ListenableSubscribable<PriceAlertsRequestEvent> {
  private restful: PriceAlertsRestful;

  constructor(session: Session) {
    super();
    this.restful = new PriceAlertsRestful(session);
  }

  public getPriceAlerts = async (): SafePromise<Partial<PriceAlerts.Alert>[]> => {
    const alerts = await ingresPriceAlerts(this.restful.getAlerts());
    if (alerts.err) {
      this.dispatch({ error: alerts.err, errorType: 'get_price_alerts_error', type: 'error' });
    }
    return alerts;
  };

  public addPriceAlert = async (
    data: Partial<PriceAlerts.PostAlertRequest>,
  ): SafePromise<Partial<PriceAlerts.PostAlertResponse>> => {
    const alerts = await ingresAddUpdatePriceAlerts(this.restful.addAlert(data));
    if (alerts.err) {
      this.dispatch({ error: alerts.err, errorType: 'add_price_alert_error', type: 'error' });
    } else {
      this.dispatch({ type: 'add_update_price_alert' });
    }
    return alerts;
  };

  public updatePriceAlert = async (
    data: Partial<PriceAlerts.PostAlertRequest>,
  ): SafePromise<Partial<PriceAlerts.PostAlertResponse>> => {
    const alerts = await ingresAddUpdatePriceAlerts(this.restful.updateAlert(data));
    if (alerts.err) {
      this.dispatch({ error: alerts.err, errorType: 'update_price_alert_error', type: 'error' });
    } else {
      this.dispatch({ type: 'add_update_price_alert' });
    }
    return alerts;
  };

  public deletePriceAlert = async (guid: string): SafePromise<Response> => {
    const alert = await this.restful.deleteAlert(guid);
    if (alert.err) {
      this.dispatch({ error: alert.err, errorType: 'delete_price_alert_error', type: 'error' });
    } else {
      this.dispatch({ type: 'add_update_price_alert' });
    }
    return alert;
  };
}
